import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, message, Table, Tag, Form, Checkbox } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import './Page2.css';
import axios from 'axios';
import { DatePicker, Space, Button } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DataGrid, GridCellParams, GridToolbar } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { makeStyles } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Backdrop } from '@mui/material';

const dateFormat = 'YYYY/MM/DD';
// const { Option } = Select;
const Inquiries: React.FC = (props: any) => {

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
        backdrop: {
            background: "black",
            zIndex: theme.zIndex.drawer + 1,
            color: "#fff",
          },
    }));

    const [enteredstatus, setEnteredStatus] = useState('');

    const statusChangeHandler = (event:any) => {
      setEnteredStatus(event.target.value);
  };

    const classes = useStyles();

    const columns = [

        { field: 'id', headerName: 'ID', width: 150 },
        { field: 'Date', headerName: 'DATE', width: 300 },
        { field: 'Email', headerName: 'EMAIL', width: 300 },
        { field: 'PhoneNumber', headerName: 'CONTACT NUMBER', width: 300 },
        { field: 'Name', headerName: 'NAME', width: 300 },
        { field: 'OwnerID', headerName: 'OWNER ID', width: 150 },
       
    ];

    const [data1, SetData] = useState([]);
    const [open, setOpen] = useState(true);

    const [PropertyObject, setPropertyObject] = useState();

    const handleBackDropClose = () => {
        setOpen(false);
      };
   
    
    useIonViewDidEnter(() => {

        axios.get('https://dev.northroom.co.za/api/bizprop/inquiries/all')
            .then(function (response) {
                // handle success
                //console.log(response.data);
                SetData(response.data);
                handleBackDropClose();
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });


    });



    const { name } = useParams<{ name: string; }>();


    return (
        <IonPage>
             <Backdrop
        className={classes.backdrop}
        open={open}
        transitionDuration={1500}
      ></Backdrop>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonRow>
                        <PageHeader
                            className="site-page-header"
                            title="Inquiries"
                        />
                    </IonRow>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen >
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">{name}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <Space direction="vertical">
                    <IonGrid>
                        <IonRow>
                            <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "1vw" }}>
                                <IonCard>
                                    <IonCardHeader>

                                    </IonCardHeader>

                                    <IonCardContent>
                                        <div style={{ height: 400, width: '80vw', paddingRight: "7.5vw" }}>
                                            <DataGrid
                                                rows={data1}
                                                columns={columns}
                                                components={{
                                                    Toolbar: GridToolbar,
                                                }}
                                                filterModel={{
                                                    items: [
                                                        { columnField: 'Name', operatorValue: 'contains', value: '' },
                                                    ],
                                                }}
                                            />
                                        </div>
                                        {/* <Table dataSource={data}>

                                            <Column title="id" dataIndex="id" />
                                            <Column title="Ammenity Status" dataIndex="Status" />
                                            <Column title="Description" dataIndex="Name" />


                                            <Column
                                                title="Action"
                                                key="action"
                                                render={(text, record: any) => (
                                                    <Space size="middle">


                                                        <Select defaultValue={record.Status} style={{ width: 120 }} onChange={(e) => { handleChange(e, record) }}>
                                                            <Option value="Enabled">Enabled</Option>
                                                            <Option value="Disabled">Blocked</Option>


                                                        </Select>



                                                    </Space>
                                                )}
                                            />
                                        </Table> */}

                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </Space>
            </IonContent>
        </IonPage>


    );
};

export default Inquiries;


